import yogaMeditation from '../assets/projects/yoga&meditation.png'
import coffeeProject from '../assets/projects/img1.jpeg'
import underConstruction from '../assets/projects/underconstruction.png'

export const data=[
    {
        id:1,
        name:"React JS Application",
        image:yogaMeditation,
        github:"https://github.com/yoga-and-meditation/yoga-and-meditation",
        live:"https://yoga-and-meditation.netlify.app/",
    },
    {
        id:2,
        name:"React JS Application",
        image:coffeeProject,
        github:"https://github.com/Kidan-Tekelearegy/coffee-project",
        live:"https://origion-of-coffee-bykidan.netlify.app/",
    },
    {
        id:3,
        name:"React JS Application",
        image:underConstruction,
        github:"",
        live:"",
    },
    


]